import { createAction } from '@reduxjs/toolkit';

export const CALL_STACK_PUSH_ACTION_TYPE = 'saga/callStackPush';
export const callStackPushAction = createAction(CALL_STACK_PUSH_ACTION_TYPE);
